import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import { myLayout, myStyle, filaColSpanObj, filaColSpanText, filaVacia, retornaArrayAncho, ponHeaderTabla, resuelveFila, resuelveFilaComplejo } from "./reportUtils";

import imageToBase64 from 'image-to-base64/browser';
import { configure } from "@testing-library/react";
import { extendUint8Array } from "js-base64";
import {logoSTJ, logoFet, logoFundeo, logoMTA}  from "./images.js"

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const BROWN = "#8D643B"
const BLUE = "#2B599F"

/* formato va a ser 
    {
        pageSize : "A4",
        pageOrientation : "portrait" o "landscape"
        pageMargins : [ 20, 20, 20, 20],
        columnas : 1 o 2, // según sea el informe
        alineación : justify,
    }

    datos va a ser
    {
        title : "Informe de caraconos",
        author:
        subject : "descripción del informe",
        keywords : "metapalabras si las hubiere"
        datos : colección de datos del informe
        titulosTabla:
        origen: Congregación, Provincia, Comunidad
        tipoInforme: Fotos, Listado simple, Listado complejo
    }    
*/

export const reportWritePdfDetalleHermana = async (
    descargar = true,
    datos = {
        title: "Informe STJ",
        author: "Congregación STJ",
        subject: "Informe STJ",
        keywords: "Informe STJ",
        datos: [],
        titulosTabla: [],
        tipoInforme: 'Listado simple',
        columnasApi: [],
        titulosComplejo:{
            headerComplejo: [],
            columnasApi: []
        }
    },
    formato = {
        pageSize: "A4",
        pageOrientation: "portrait",
        pageMargins: [20, 40, 20, 20],
        columnas: 1,
        alineacion: "justify",
        origen: "Congregación",
    },

) => {

    console.log('datos')
    console.log(datos)


    if(datos.datos.length === 0){
        alert('El informe arroja datos. Compruebe su existencia en la base de datos')
    }else{

    //////////////////////////////////////////////////////////////////////////////MOTAJE DE INFORME
    const docDefinition = {

        info: {
            title: datos.title,
            author: datos.author,
            subject: datos.subject,
            keywords: datos.keywords,
        },

        font: "https://fonts.googleapis.com/css?family=Comfortaa",
        pageSize: formato.pageSize,
        pageOrientation: formato.pageOrientation,
        pageMargins: formato.pageMargins,

        // HEADER #########################################################################################
        header: {
            columns: [
                {
                    image: 'data:image/jpeg;base64,' + logoSTJ(),
                    width: 100,
                    height: 40,
                    margin: [20, 15, 30, 10]
                },
                {
                    text: datos.title,
                    alignment: 'center',
                    margin: [20,20],
                    style: ['h3', 'c2', 'w1'],
                },
                {
                    alignment: 'right',
                    width: '30%',
                    text: "Impresión: " + new Date().toJSON().slice(0, 10)
                        + " " + new Date().toJSON().slice(11, 16),
                    style: ['h6', 'c2', 'w1'],
                    margin: [20, 15, 20, 10]
                },
            ],
        },
        // FOOTER #########################################################################################

        footer: function (currentPage, pageCount, pageSize) {
            // you can apply any logic and return any valid pdfmake element

            return [
                {
                    columns: [{
                        text: currentPage.toString() + ' de ' + pageCount,
                        alignment: (currentPage % 2) ? 'left' : 'right',
                        margin: (currentPage % 2) ? [20, 10, 1, 10] : [1, 10, 20, 10],
                        style: ['h4', 'c2', 'w1'],
                    },
                    {
                        text: datos.title,
                        alignment: 'center',
                        style: ['h5', 'c2', 'w1'],
                        margin: [20, -10, 20, 10],
                    },
                    ],
                },
            ]
        },

        // BACKGROUND#########################################################################################
        background: function (currentPage, pageSize) {
            console.log(currentPage)
            console.log(pageSize)
            return [
                {
                    canvas: [
                        { type: 'line', x1: 5, y1: 5, x2: 590, y2: 5, lineWidth: 0.5, color: BROWN }, //Up line
                        { type: 'line', x1: 5, y1: 5, x2: 5, y2: 835, lineWidth: 0.5, color: BROWN }, //Left line
                        { type: 'line', x1: 5, y1: 835, x2: 590, y2: 835, lineWidth: 0.5, color: BROWN }, //Bottom line
                        { type: 'line', x1: 590, y1: 5, x2: 590, y2: 835, lineWidth: 0.5, color: BROWN }, //Rigth line
                    ]

                }
            ]
        },

        // CONTENIDO #########################################################################################

        content: [
            //llamo a una función que me va a devolver la tabla completa correcta
            await lanzaInforme(datos, 5, 100, '%', logoSTJ(), datos.tipoInforme),

        ],

        // DEFAULT STYLE#####################################################################################
        defaultStyle: {
            fontSize: 10,
            bold: false,
            italics: false,
            alignment: 'left',
            /*characterSpacing: number: size of the letter spacing in pt
            color: string: the color of the text (color name e.g., ‘blue’ or hexadecimal color e.g., ‘#ff5500’)
            background: string the background color of the text
            markerColor: string: the color of the bullets in a buletted list
            decoration: string: the text decoration to apply (‘underline’ or ‘lineThrough’ or ‘overline’)
            decorationStyle: string: the style of the text decoration (‘dashed’ or ‘dotted’ or ‘double’ or ‘wavy’)
            decorationColor: string: the color of the text decoration, see color
            font: string: name of the font
            fontSize: number: size of the font in pt
            fontFeatures: string[]: array of advanced typographic features supported in TTF fonts (supported features depend on font file)
            lineHeight: number: the line height (default: 1)*/
        },

        // IMÁGENES #########################################################################################

        //precarga de imagenes a través de llamadas a api o lo que sea
        images: {
           

        },
        styles: myStyle,
    };
   
    //descargar o mostrar en navegador
    if (datos.descargar) {
        pdfMake.createPdf(docDefinition).download(`${datos.title}.pdf`)
    } else {
        try {
            pdfMake.createPdf(docDefinition).open(window)
        } catch (err) {
            alert('Tiene activado el bloqueador de emergentes. Desactívelo y lance de nuevo el informe');
        }

    }
    }
}

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
const lanzaInforme = async (datos, noColumnas, ancho, porcentaje, logo, tipoInforme) => {
    console.log('tipo informe: ' + tipoInforme)
    switch (tipoInforme) {
        case 'Listado detalle hermana': return await lanzaInformeDetalleHermanas(datos, noColumnas, ancho, porcentaje)
        default:
    }

}
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



///-------------------------------------------------------------------------------------5.1 INFORME DETALLE HERMANAS
//FUNCIÓN PRINCIPAL INFORME HERMANAS
const lanzaInformeDetalleHermanas = async (datos, noColumnas, ancho, porcentaje) => {
    
    //el número de columnas lo da la longitud del array de titulosTabla
    //let filas = await adaptaDatosTablaListadoDetalleHermanas(datos.datos, datos.titulosTabla.length, datos.titulosTabla, datos.columnasApi, datos.titulosComplejo.headerComplejo, datos.titulosComplejo.columnasApi, datos.titulosComplejoDetalle.headerDetalle, datos.titulosComplejoDetalle.columnasDetalleApi,  datos.titulosComplejoDetalle.campoDetalle, datos.titulosComplejoDetalle.saltaDePagina)
    return {
        layout: 'headerLineOnly',//'lightHorizontalLines',
        style: ['m10', 'h5'],
        table: {
            headerRows: 0,
            widths: ["20%", "28%", "20%", "28%"], //retornaArrayAncho(4, 95, "%", false), //["20%", "20%", "20%", "20%", "20%"," 20%",], //'*', 'auto', '30%'],//, 100, '*' ],
            body:
                [
                    
                    
                    ...fncion(datos.datos),
                    

                   
                ]
        },
    }
}


const fila = ( colspan, columnaColSpan, rowspan, columnaRowSpan, columnas, texto, esTitulo, estiloIgual, estiloDoble, subTitulo = true, pageBreak=false) => {
    const estiloTitulo1 = ['h4', 'fwhiteBrown', 'center']
    const estiloTitulo2 = ['h5', 'fwhiteBlue', 'center']
    const estilo1 = ['h5', 'cblue', 'left']
    const estilo2 = ['h5', 'cbrown', 'left']
    let array=[]
    for(let i=1; i<=columnas; i++){
        array.push({text: texto[i-1], colSpan: i===columnaColSpan ? colspan : 1, rowSpan: i===columnaRowSpan ? rowspan : 1, style: esTitulo ? subTitulo ? estiloTitulo1 : estiloTitulo2 : estiloIgual ? estilo1 : i===1 ? estilo1 : estiloDoble ? i%2===1 ? estilo1 : estilo2 : estilo2,  pageBreak: pageBreak ? 'before': ''})
    }
    return array
}

const fncion = (datos) =>{
    const user=datos.usuario
    const dest=datos.usuario.sister.destinations
    const sister=datos.usuario.sister
    const rPeriods=datos.usuario.sister.religous_periods
    const rStudios=datos.usuario.sister.religious_studies
    const education=datos.usuario.education
    const ict=datos.usuario.ict_skills
    const cargos=datos.cargos
    const cargosFT=datos.cargosFT
    const languages=datos.usuario.languages
    const cargosEx= datos.usuario.cargosextras

    let array = []
    array.push([
        { text: `${user.name} ${user.firstSurname} ${user.secondSurname}`, style: ['h1', 'fc2', 'bold', 'center', 'cblue'], colSpan: 3}, {text:''}, {text:''}, 
        {
            image: 'data:image/jpeg;base64,' + datos.photo,
            fit: [150, 150],
            //width: 150,
            //height: 150,
            //margin: [20, 15, 20, 10],
            style: ['center'],
            rowSpan: 8
            
        }
    ])
   
    array.push(fila( 3, 1, 1, 1, 4, [""], true))
    array.push(fila( 3, 1, 1, 1, 4, ["DATOS PERSONALES"], true))
    array.push(fila( 1, 1, 1, 1, 4, ["Nacionalidad:", user.nationality ], false))
    array.push(fila( 1, 1, 1, 1, 4, [`F. Nacimiento${sister.decease ? ' - Defunción' : ''}:`, `${user.birthdate}`, `${sister.decease ? sister.decease+' ('+sister.deceasePlace+')' : ''}`, ''], false, false, true))
    sister.decease && array.push(fila( 1, 1, 1, 1, 4, [`F. Entierro - Lugar:`, sister.burial, sister.burialPlace, ''], false, false, true))
    array.push(fila( 1, 1, 1, 1, 4, [`Nacida en: `, `${user.birthAddress} - ${user.birthProvince}`, user.birthCountry, ''], false, false, true))
    
    array.push(fila( 1, 1, 1, 1, 4, [`${user.documentType} - Pasaporte: `, `${user.documentId}`, user.passport, ''], false, false, true))
    array.push(fila( 1, 1, 1, 1, 4, [`email - teléfono: `, `${user.email}`, `${user.telephone}`, ''], false, false, true))
    array.push(fila( 1, 1, 1, 1, 4, [`Carnet de conducir: `, `${user.drivingLicense === ('0' || '') ? 'NO' : 'SI'}`, ``, ''], false, false, true))
    array.push(fila( 1, 1, 1, 1, 4, [`Bautismo en: `, `${sister.baptismPlace}`, 'Fecha:', sister.baptism], false, false, true))
    array.push(fila( 1, 1, 1, 1, 4, [`Confirmación en: `, `${sister.confirmationPlace}`, 'Fecha:', sister.confirmation], false, false, true))
    
    array.push(fila( 3, 1, 1, 1, 4, [""], true))
    array.push(fila( 3, 1, 1, 1, 4, ["DATOS FAMILIARES Y CONTACTO"], true))
    
    array.push(fila( 1, 1, 1, 1, 4, [`Padre: ${sister.fatherAlive ? '(Fallecido)' : ''}`, `${sister.fatherName} ${sister.fatherSurname}`,`Madre: ${sister.motherAlive ? '(Fallecida)' : ''}`, `${sister.motherName} ${sister.motherSurname}`], false, false, true))
    array.push(fila( 1, 1, 1, 1, 4, [`Dirección padre: `, `${sister.fatherAddress} ${sister.fatherProvince} ${sister.fatherCountry}`,`Dirección madre:`, `${sister.motherAddress} ${sister.motherProvince} ${sister.motherCountry}`], false, false, true))
    array.push(fila( 1, 1, 1, 1, 4, [`Persona contacto: `, `${sister.contactName} ${sister.contactSurname}`,`Parentesco:`, `${sister.contactRelationship}`], false, false, true))
    array.push(fila( 1, 1, 1, 1, 4, [`email - teléfono: `, `${sister.contactEmail} - ${sister.contactTelephone}`,`Dirección contacto:`, `${sister.contactAddress} ${sister.contactProvince} ${sister.contactCountry}`], false, false, true))

    array.push(fila( 3, 1, 1, 1, 4, [""], true))
    array.push(fila( 3, 1, 1, 1, 4, ["VIDA RELIGIOSA"], true))
    array.push(fila( 1, 1, 1, 1, 4, [`Compañía: `, `${sister.companyNumber ? sister.companyNumber : ''} ${sister.companyName ? sister.companyName : ''}`,'F. Entrada:', `${sister.entrySTJ ? sister.entrySTJ : ''}`], false, false, true))
    

    //VOTOS
    array.push(fila( 2, 3, 1, 1, 4, [`VOTOS`, `Fecha`,'Comunidad', ``], true, true, true, false))
    rPeriods.forEach((periodo) => {
        array.push(fila( 2, 3, 1, 1, 4, [`${periodo.vow_type.type}`, `${periodo.date}`, `${periodo.community.name}`, ``], false, true, true))
        
    })
  
    //DESTINOS
    array.push(fila( 1, 1, 1, 1, 4, [`DESTINOS`, `Fechas inicio y fin`,'Destino', ``], true, true, true, false))
    dest.forEach((destino) => {
        array.push(fila( 2, 3, 1, 1, 4, [`${destino.province.name}`, `${destino.startDate} ${destino.endDate ? '/ '+destino.endDate : ''}`, `${destino.province.key} ${destino.community.name}`, ``], false, true, true))
        
    })

    //FORMACIÓN ETAPA RELIGIOSA
    array.push(fila( 1, 1, 1, 1, 4, [`ESTUDIOS RELIGIOSOS`, `Fecha`,'Lugar', ``], true, true, true, false))
    rStudios.forEach((estudio) => {
        array.push(fila( 1, 1, 1, 1, 4, [`${estudio.religiousStudies}`, `${estudio.religiousStudiesYear}`, `${estudio.religiousStudiesPlace}`, ``], false, true, true))
        
    })

    //DATOS FORMACIÓN
    array.push(fila( 3, 1, 1, 1, 4, [""], true))
    array.push(fila( 3, 1, 1, 1, 4, ["DATOS FORMACIÓN"], true))

    education.length > 0 && array.push(fila( 2, 3, 1, 1, 4, [`ESTUDIOS `, `Fecha`,'Área / Lugar', ``], true, true, true, false))
    education.forEach((estudio) => {
        array.push(fila( 2, 3, 1, 1, 4, [`${estudio.study_level.type} ${estudio.name}`, `${estudio.date}`, `${estudio.study_field.type} / ${estudio.center}`, ``], false, true, true))
        
    })

    ict.length > 0 && array.push(fila( 2, 3, 1, 1, 4, [`ESTUDIOS INFORMÁTICOS`, `Nivel`,'', ``], true, true, true, false))
    ict.forEach((estudio) => {
        array.push(fila( 2, 3, 1, 1, 4, [`${estudio.programName}`, `${estudio.level}`, ``, ``], false, true, true))
        
    })

    languages.length > 0 && array.push(fila( 2, 2, 1, 1, 4, [`IDIOMAS`, 'Certificado', `Nivel`, ``], true, true, true, false))
    languages.forEach((estudio) => {
        array.push(fila( 2, 3, 1, 1, 4, [`${estudio.name}`, `${estudio.certificate}`, `${estudio.language_level.type}`, ``], false, true, true))
        
    })

    //MISIÓN
    array.push(fila( 3, 1, 1, 1, 4, [""], true, false, false, false, true))
    array.push(fila( 3, 1, 1, 1, 4, ["MISIÓN"], true))
    //Dirección General
    array.push(fila( 2, 3, 1, 1, 4, [`ÓRGANO `, `Cargo`,'F. Inicio / F. Fin', ``], true, true, true, false))
    cargos.forEach((cargo) => {
        array.push(fila( 2, 3, 1, 1, 4, [`${cargo.cargo.Órgano}`, `${cargo.cargo.Cargo}`, `${cargo.cargo['Fecha inicio'] ? cargo.cargo['Fecha inicio'] : ''}${cargo.cargo['Fecha fin'] ? ' / '+cargo.cargo['Fecha fin'] : ''}`, ``], false, true, true))
        
    })

    array.push(fila( 2, 3, 1, 1, 4, [`FAMILIA TERESIANA `, `Cargo`,'F. Inicio / F. Fin', ``], true, true, true, false))
    cargosFT.forEach((cargo) => {
        array.push(fila( 2, 3, 1, 1, 4, [`${cargo.cargo.Órgano}`, `${cargo.cargo.Cargo}`, `${cargo.cargo['Fecha inicio'] ? cargo.cargo['Fecha inicio'] : ''}${cargo.cargo['Fecha fin'] ? ' / '+cargo.cargo['Fecha fin'] : ''}`, ``], false, true, true))
        
    })

    array.push(fila( 1, 1, 1, 1, 4, [`OTRA MISIÓN `, 'F. Inicio / F. Fin', 'Lugar', 'Nivel'], true, true, true, false))
    cargosEx.forEach((cargo) => {
        array.push(fila( 1, 1, 1, 1, 4, [cargo.cargo, `${cargo.startDate ? cargo.startDate : ''} ${cargo.endDate ? ' / '+cargo.endDate : ''}`, cargo.lugar, cargo.nivel], false, true, true))
        cargo.descripcion && array.push(fila( 4, 1, 1, 1, 4, [cargo.descripcion, '', '', ''], false, true, true))
        cargo.mission && array.push(fila( 1, 1, 1, 1, 4, [cargo.mission.name, cargo.mission.province.key, cargo.mission.country, cargo.mission.category], false, true, true))
        cargo.descripcion && array.push(fila( 4, 1, 1, 1, 4, ['____', '', '', ''], false, true, true))
        
        
    })
    


    return array

}
























///-------------------------------------------------------------------------------------5. INFORME DETALLE HERMANAS
//FUNCION PARA ADAPTAR LOS DATOS A TABLA EN COLUMNAS DE noColumnas
const adaptaDatosTablaListadoDetalleHermanas = async (datos, noColumnas, titulosTabla, columnasApi, titulosTablaComplejo, columnasApiComplejo, titulosTablaComplejoDetalle, columnasApiComplejoDetalle, campoDetalle, saltaDePagina) => {
    let tablaAdaptada = [] //tabla final a devolver para mostrar en
    let saltoPagina=false
    
    for (const dato of datos) {
        //salto de página
        tablaAdaptada.push(filaColSpanText(titulosTabla.length,titulosTabla.length,'',saltoPagina))
        //titulos agrupación
        tablaAdaptada.push(ponHeaderTabla(titulosTabla.length, titulosTablaComplejo, false))
        //datos agrupación
        tablaAdaptada.push(resuelveFilaComplejo(dato, columnasApiComplejo, columnasApi.length, saltoPagina))
        tablaAdaptada.push(ponHeaderTabla(titulosTabla.length, titulosTabla, false))

        for (const tupla of dato.tuplas) {
            tablaAdaptada.push(resuelveFila(tupla, columnasApi,[ 'bold', 'h5']))

            //detalle
            tablaAdaptada.push(ponHeaderTabla(titulosTabla.length, titulosTablaComplejoDetalle, false, 1, ['fwhiteBlue', 'h5']))
            for (const detalle of tupla[campoDetalle]) {
                tablaAdaptada.push(resuelveFilaComplejo(detalle, columnasApiComplejoDetalle,columnasApi.length, false, 1,['cazul', 'h5']))
                
            }
            filaVacia(titulosTabla.length)

        }
        
        saltoPagina=saltaDePagina
        filaVacia(titulosTabla.length)
    }
    return tablaAdaptada
}































///---------------------------------------------------------------------------------------1. FOTOS
//FUNCION PARA ADAPTAR LOS DATOS A TABLA EN COLUMNAS DE noColumnas
const adaptaDatosTablaFotos = async (datos, noColumnas, filasAMontar) => {
    let conFilaAuxiliar = 0
    let noIteraciones = 0   //elementos de los tuplas
    let noPackColumnas = 0
    let indiceTablaAdaptada = 0  //contador filas de tabla Adaptada final
    //elementos de la tabla
    let banderaSaltoPagina = false

    let fila = []   //fila de tabla final fotos
    let fila2 = []  //fila de tabla final nombre
    let fila3 = []  //fila de tabla final apellidos
    let tablaAdaptada = [] //tabla final a devolver para mostrar en

    //control de comunidad

    for (let n = 0; n < datos.length; n++) {
        if(banderaSaltoPagina){
            //linea horizontal en la primera página no
            //tablaAdaptada[indiceTablaAdaptada] = filaColSpanObj(noColumnas, noColumnas, { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 545, y2: 0, lineWidth: 2, color: 'black' }] })
            //indiceTablaAdaptada++
        }
        //linea horizontal
        //tablaAdaptada[indiceTablaAdaptada] = filaColSpanObj(noColumnas, noColumnas, { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 0.5 }] })
        //indiceTablaAdaptada++
        //titulo de la comunidad
        tablaAdaptada[indiceTablaAdaptada] = filaColSpanText(noColumnas, noColumnas, datos[n].communityName ? `${datos[n].provinceName} - ${datos[n].communityName}` : '', banderaSaltoPagina)
        indiceTablaAdaptada++
        //linea horizontal
        tablaAdaptada[indiceTablaAdaptada] = filaColSpanObj(noColumnas, noColumnas, { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 300, y2: 0, lineWidth: 0.5, color: BLUE }] })
        indiceTablaAdaptada++
        //linea vacia
        tablaAdaptada[indiceTablaAdaptada] = filaVacia(noColumnas)
        indiceTablaAdaptada++
        //solo para la primera entrada
        banderaSaltoPagina = false
        //calculo el no de iteraciones que voy a realizar

        if (datos[n].contador % noColumnas === 0) {
            //si el resto es 0 es el contador de elementos que tiene el array
            noIteraciones = datos[n].contador
        } else {
            //si no tengo que añadir a los elementos la diferencia del numero de columans y el resto de la division
            noIteraciones = datos[n].contador + noColumnas - (datos[n].contador % noColumnas)
        }

        for (let k = 0; k < noIteraciones; k++) {
            //recorro la subdata con y guardo en la tabla los valores

            if (datos[n].tuplas[k]) {
                //hay elemento en la tupla

                fila[conFilaAuxiliar] = {
                    image: 'data:image/jpeg;base64,' + datos[n].tuplas[k].fotico,
                    fit: [100, 100],
                    //width: 150,
                    //height: 150,
                    //margin: [20, 15, 20, 10],
                    style: ['center']
                }
                //nombre
                fila2[conFilaAuxiliar] = { 'text': `${datos[n].tuplas[k].userName}`, style: ['h4', 'fazul', 'bold', 'cwhite', 'center'] }
                //algo más
                fila3[conFilaAuxiliar] = { 'text': `${datos[n].tuplas[k].apell1} ${datos[n].tuplas[k].apell2}`, style: ['h5', 'fazul', 'bold', 'cwhite', 'center'] }
            } else {
                fila[conFilaAuxiliar] = { 'text': '' }
                fila2[conFilaAuxiliar] = { 'text': '' }
                fila3[conFilaAuxiliar] = { 'text': '' }
            }
            conFilaAuxiliar++
        }

        for (let j = 0; j < (noIteraciones / noColumnas); j++) {

            tablaAdaptada[indiceTablaAdaptada] = fila.slice(noColumnas * noPackColumnas, (noColumnas * noPackColumnas) + noColumnas)
            indiceTablaAdaptada++
            tablaAdaptada[indiceTablaAdaptada] = fila2.slice(noColumnas * noPackColumnas, (noColumnas * noPackColumnas) + noColumnas)
            indiceTablaAdaptada++
            tablaAdaptada[indiceTablaAdaptada] = fila3.slice(noColumnas * noPackColumnas, (noColumnas * noPackColumnas) + noColumnas)
            indiceTablaAdaptada++

            noPackColumnas++ //valor para calcular el subarray de la subtabla fila que hay q poner en cada fila 
        }

        //aqúi podemos poner la separación entre comunidades
         //linea horizontal en la primera página no
         tablaAdaptada[indiceTablaAdaptada] = filaColSpanObj(noColumnas, noColumnas, { canvas: [{ type: 'line', x1: 0, y1: 10, x2: 545, y2: 0, lineWidth: 1.5, color: 'white' }] })
         indiceTablaAdaptada++
         tablaAdaptada[indiceTablaAdaptada] = filaColSpanObj(noColumnas, noColumnas, { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 545, y2: 0, lineWidth: 1, color: BROWN }] })
         indiceTablaAdaptada++
         tablaAdaptada[indiceTablaAdaptada] = filaColSpanObj(noColumnas, noColumnas, { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 545, y2: 0, lineWidth: 1, color: BROWN }] })
         indiceTablaAdaptada++
         tablaAdaptada[indiceTablaAdaptada] = filaColSpanObj(noColumnas, noColumnas, { canvas: [{ type: 'line', x1: 0, y1: 10, x2: 545, y2: 0, lineWidth: 1.5, color: 'white' }] })
         indiceTablaAdaptada++
         
    }
    return tablaAdaptada
}
///--------------------------------------------------------------------------------------1.2 FOTOS
//FUNCIÓN PRINCIPAL TABLA DATOS TIPO FOTO
const lanzaInformeFotos = async (datos, noColumnas, ancho, porcentaje, logo) => {
    let filas = await adaptaDatosTablaFotos(datos.datos, noColumnas, ['photo', 'Nombre', 'Cargo',])
    return {
        layout: 'headerLineOnly',
        style: ['m10'],
        table: {
            headerRows: 0,
            widths: retornaArrayAncho(noColumnas, ancho, porcentaje), //["20%", "20%", "20%", "20%", "20%"," 20%",], //'*', 'auto', '30%'],//, 100, '*' ],
            body:
                [
                    /*[{ text: '11' , colSpan: 5}, {text:''}, {text:''}, {text:''}, {text:''}],*/
                    //filaColSpan(noColumnas,noColumnas, 'Título a poner de la comunidad', false),
                    //filaVacia(noColumnas),
                    //...header,
                    /*  [{text: 'Concepto', style: ['h5', 'fc11', 'cb']},{text: item.text, style: ['h4', 'fc2', 'b', 'c2']}],*/
                    ...filas,
                ]
        },
    }
}

///--------------------------------------------------------------------------------------2. SIMPLE
//FUNCION PARA ADAPTAR LOS DATOS A TABLA EN COLUMNAS DE noColumnas
const adaptaDatosTablaListadoSimple = async (datos, noColumnas, titulosTabla, columnasApi) => {
    let tablaAdaptada = [] //tabla final a devolver para mostrar en
    for (const dato of datos) {
        tablaAdaptada.push(resuelveFila(dato, columnasApi))
    }
    return tablaAdaptada
}
///-------------------------------------------------------------------------------------2.2 SIMPLE
//FUNCIÓN PRINCIPAL TABLA DATOS TIPO LISTADO SIMPLE
const lanzaInformeListadoSimple = async (datos, noColumnas, ancho, porcentaje, logo) => {
    //el número de columnas lo da la longitud del array de titulosTabla
    let filas = await adaptaDatosTablaListadoSimple(datos.datos, datos.titulosTabla.length, datos.titulosTabla, datos.columnasApi)
    return {
        layout: 'lightHorizontalLines',
        style: ['m10', 'h5'],
        table: {
            headerRows: 1,
            widths: retornaArrayAncho(datos.titulosTabla.length, ancho, porcentaje, true), //["20%", "20%", "20%", "20%", "20%"," 20%",], //'*', 'auto', '30%'],//, 100, '*' ],
            body:
                [
                    //[{ text: '11' , colSpan: 5}, {text:''}, {text:''}, {text:''}, {text:''}],
                    ponHeaderTabla(datos.titulosTabla.length, datos.titulosTabla),
                    //filaColSpan(noColumnas,noColumnas, 'Título a poner de la comunidad', false),
                    //filaVacia(noColumnas),
                    //...header,
                    /*  [{text: 'Concepto', style: ['h5', 'fc11', 'cb']},{text: item.text, style: ['h4', 'fc2', 'b', 'c2']}],*/
                    ...filas,
                ]
        },
    }
}



///-------------------------------------------------------------------------------------3. COMPLEJO
//FUNCION PARA ADAPTAR LOS DATOS A TABLA EN COLUMNAS DE noColumnas
const adaptaDatosTablaListadoComplejo = async (datos, noColumnas, titulosTabla, columnasApi, titulosTablaComplejo, columnasApiComplejo) => {
    let tablaAdaptada = [] //tabla final a devolver para mostrar en
    let saltoPagina=false
    for (const dato of datos) {
        //salto de página
        tablaAdaptada.push(filaColSpanText(titulosTabla.length,titulosTabla.length,'',saltoPagina))
        //titulos agrupación
        tablaAdaptada.push(ponHeaderTabla(titulosTabla.length, titulosTablaComplejo, false, 0, ['fwhiteBlue', 'h4']))
        //datos agrupación
        tablaAdaptada.push(resuelveFilaComplejo(dato, columnasApiComplejo, columnasApi.length, false))
        tablaAdaptada.push(ponHeaderTabla(titulosTabla.length, titulosTabla, false))
        for (const tupla of dato.tuplas) {
            tablaAdaptada.push(resuelveFila(tupla, columnasApi))
        }
        saltoPagina=true
    }
    return tablaAdaptada
}
///-------------------------------------------------------------------------------------3.1 COMPLEJO
//FUNCIÓN PRINCIPAL TABLA DATOS TIPO LISTADO COMPLEJO
const lanzaInformeListadoComplejo = async (datos, noColumnas, ancho, porcentaje, logo) => {
    //el número de columnas lo da la longitud del array de titulosTabla
    let filas = await adaptaDatosTablaListadoComplejo(datos.datos, datos.titulosTabla.length, datos.titulosTabla, datos.columnasApi, datos.titulosComplejo.headerComplejo, datos.titulosComplejo.columnasApi)
    return {
        layout: 'headerLineOnly',
        style: ['m10', 'h5'],
        table: {
            headerRows: 0,
            widths: retornaArrayAncho(datos.titulosTabla.length, ancho, porcentaje, true), //["20%", "20%", "20%", "20%", "20%"," 20%",], //'*', 'auto', '30%'],//, 100, '*' ],
            body:
                [
                    //[{ text: '11' , colSpan: 5}, {text:''}, {text:''}, {text:''}, {text:''}],
                    
                    //filaColSpan(noColumnas,noColumnas, 'Título a poner de la comunidad', false),
                    //filaVacia(noColumnas),
                    //...header,
                    /*  [{text: 'Concepto', style: ['h5', 'fc11', 'cb']},{text: item.text, style: ['h4', 'fc2', 'b', 'c2']}],*/
                    ...filas,
                ]
        },
    }
}

///-------------------------------------------------------------------------------------4. COMPLEJO DETALLE
//FUNCION PARA ADAPTAR LOS DATOS A TABLA EN COLUMNAS DE noColumnas
const adaptaDatosTablaListadoComplejoDetalle = async (datos, noColumnas, titulosTabla, columnasApi, titulosTablaComplejo, columnasApiComplejo, titulosTablaComplejoDetalle, columnasApiComplejoDetalle, campoDetalle, saltaDePagina) => {
    let tablaAdaptada = [] //tabla final a devolver para mostrar en
    let saltoPagina=false
    
    for (const dato of datos) {
        //salto de página
        tablaAdaptada.push(filaColSpanText(titulosTabla.length,titulosTabla.length,'',saltoPagina))
        //titulos agrupación
        tablaAdaptada.push(ponHeaderTabla(titulosTabla.length, titulosTablaComplejo, false))
        //datos agrupación
        tablaAdaptada.push(resuelveFilaComplejo(dato, columnasApiComplejo, columnasApi.length, saltoPagina))
        tablaAdaptada.push(ponHeaderTabla(titulosTabla.length, titulosTabla, false))

        for (const tupla of dato.tuplas) {
            tablaAdaptada.push(resuelveFila(tupla, columnasApi,[ 'bold', 'h5']))

            //detalle
            tablaAdaptada.push(ponHeaderTabla(titulosTabla.length, titulosTablaComplejoDetalle, false, 1, ['fwhiteBlue', 'h5']))
            for (const detalle of tupla[campoDetalle]) {
                tablaAdaptada.push(resuelveFilaComplejo(detalle, columnasApiComplejoDetalle,columnasApi.length, false, 1,['cazul', 'h5']))
                
            }
            filaVacia(titulosTabla.length)

        }
        
        saltoPagina=saltaDePagina
        filaVacia(titulosTabla.length)
    }
    return tablaAdaptada
}
///-------------------------------------------------------------------------------------4.1 COMPLEJO DETALLE
//FUNCIÓN PRINCIPAL TABLA DATOS TIPO LISTADO COMPLEJO
const lanzaInformeListadoComplejoDetalle = async (datos, noColumnas, ancho, porcentaje, logo) => {
    //el número de columnas lo da la longitud del array de titulosTabla
    let filas = await adaptaDatosTablaListadoComplejoDetalle(datos.datos, datos.titulosTabla.length, datos.titulosTabla, datos.columnasApi, datos.titulosComplejo.headerComplejo, datos.titulosComplejo.columnasApi, datos.titulosComplejoDetalle.headerDetalle, datos.titulosComplejoDetalle.columnasDetalleApi,  datos.titulosComplejoDetalle.campoDetalle, datos.titulosComplejoDetalle.saltaDePagina)
    return {
        layout: 'headerLineOnly',//'lightHorizontalLines',
        style: ['m10', 'h5'],
        table: {
            headerRows: 0,
            widths: retornaArrayAncho(datos.titulosTabla.length, ancho, porcentaje, true), //["20%", "20%", "20%", "20%", "20%"," 20%",], //'*', 'auto', '30%'],//, 100, '*' ],
            body:
                [
                    //[{ text: '11' , colSpan: 5}, {text:''}, {text:''}, {text:''}, {text:''}],
                    
                    //filaColSpan(noColumnas,noColumnas, 'Título a poner de la comunidad', false),
                    //filaVacia(noColumnas),
                    //...header,
                    /*  [{text: 'Concepto', style: ['h5', 'fc11', 'cb']},{text: item.text, style: ['h4', 'fc2', 'b', 'c2']}],*/
                    ...filas,
                ]
        },
    }
}



